import React, { Fragment } from 'react';
import { bool } from 'prop-types';
// import { styWrapper } from 'components/organism/styles';

function FooterSection({ isInvitation }) {
  return (
    <Fragment>
      {/* {!isInvitation && (
        <div id="fh5co-couple" className="fh5co-section-gray" css={styWrapper}>
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 text-center fh5co-heading">
                <h2 className="main-font">Terima Kasih</h2>
                <p className="info">
                  Berdasarkan kondisi saat ini, tanpa mengurangi rasa hormat, diharapkan tetap bisa menjalin silaturahmi
                  melalui media online, bukan dengan kontak fisik secara langsung. <br />
                  Mohon pengertiannya.
                </p>
                <p className="info">
                  Atas segala do'a dan restu saudara/i,
                  <br /> kami ucapkan terima kasih. <br />
                  Wassalamualaikum warahmatullahi wabarakatuh.
                </p>
              </div>
            </div>
          </div>
        </div>
      )} */}
      <footer id="fh5co-footer" role="contentinfo">
        <div className="container">
          <div className="row copyright">
            <div className="col-md-12 text-center">
              <p>
                <small className="block">&copy; 2022 Shania & Torik Wedding. All Rights Reserved.</small>
                <small className="block">
                  Covid-19 Icon by{' '}
                  <a href="https://www.flaticon.com/packs/covid-protection-measures-5" target="_blank" rel="noreferrer">
                    Flat Icon - Frepik
                  </a>
                </small>
                <small className="block">
                  Song by{' '}
                  <a href="https://www.youtube.com/watch?v=fb167KAxvrg" target="_blank" rel="noreferrer">
                    Anandito Anisa - Pernikahan Impian
                  </a>
                </small>
                <small className="block">
                  Design Inspired by {' '}
                  <a href="https://dribbble.com/tags/wedding_website" target="_blank" rel="noreferrer">
                    Dribble.com
                  </a>
                </small>
                <br/>
                <small className="block">
                  Made with {' '} 
                  <a href="https://reactjs.org/" target="_blank" rel="noreferrer">
                    ❤️
                  </a> by {' '}
                  <a href="https://wa.me/+6285864603871?text=Halo kak pengen buat website atau aplikasi dong">
                    Torik
                  </a>
                </small>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </Fragment>
  );
}

FooterSection.propTypes = {
  isInvitation: bool.isRequired,
};

export default React.memo(FooterSection);
